import React from "react";
import { BsCheckCircle, BsCircle } from "react-icons/bs";
import "../../../style/buttons.scss";
import "../../../style/block.scss";
import "./style/style.scss";
import { useTranslation } from "react-i18next";
import useFacility from "../../../utils/hooks/useFacility";
interface IProps {
  invoiceType: "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice";
  setInvoiceType: (value: "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice") => void;
}

const InvoiceButtons: React.FC<IProps> = ({ invoiceType, setInvoiceType }: IProps) => {
  const { t } = useTranslation();
  const facilityIds = useFacility();

  return (
    <React.Fragment>
      <div className="InvoiceButtons">
        <button
          type={"button"}
          onClick={() => setInvoiceType("noInvoice")}
          className={
            invoiceType === "noInvoice"
              ? "full-button button medium padding-medium button-toggle-main-active"
              : "full-button button medium padding-medium button-toggle-main"
          }
        >
          {invoiceType !== "noInvoice" && <BsCircle className="icon" />}
          {invoiceType === "noInvoice" && <BsCheckCircle className="icon" />}
          {t("bez_faktury")}
        </button>
        <button
          type={"button"}
          onClick={() => setInvoiceType("customerInvoice")}
          className={
            invoiceType === "customerInvoice"
              ? "full-button button medium padding-medium button-toggle-main-active"
              : "full-button button medium padding-medium button-toggle-main"
          }
        >
          {invoiceType !== "customerInvoice" && <BsCircle className="icon" />}
          {invoiceType === "customerInvoice" && <BsCheckCircle className="icon" />}
          {t("faktura_na_osobe")}
        </button>
        <button
          type={"button"}
          onClick={() => setInvoiceType("companyInvoice")}
          className={
            invoiceType === "companyInvoice"
              ? "full-button button medium padding-medium button-toggle-main-active"
              : "full-button button medium padding-medium button-toggle-main"
          }
        >
          {invoiceType !== "companyInvoice" && <BsCircle className="icon" />}
          {invoiceType === "companyInvoice" && <BsCheckCircle className="icon" />}
          {t("faktura_na_firme")}
        </button>
        {facilityIds === "1220" && (
          <button
            type={"button"}
            onClick={() => setInvoiceType("recipientAndPurchaserInvoice")}
            className={
              invoiceType === "recipientAndPurchaserInvoice"
                ? "full-button button medium padding-medium button-toggle-main-active"
                : "full-button button medium padding-medium button-toggle-main"
            }
          >
            {invoiceType !== "recipientAndPurchaserInvoice" && <BsCircle className="icon" />}
            {invoiceType === "recipientAndPurchaserInvoice" && <BsCheckCircle className="icon" />}
            {t("faktura_na_nabywce_odbiorce")}
          </button>
        )}
      </div>
    </React.Fragment>
  );
};

export default InvoiceButtons;
